import { Pipe, PipeTransform } from '@angular/core';
import { Role } from '../_models/role';

@Pipe({
  name: 'roleCheck',
})
export class RoleCheckPipe implements PipeTransform {
  transform(currentRole: Role | undefined, permittedRoles: Role[]): boolean {
    return currentRole !== undefined && permittedRoles.includes(currentRole);
  }
}
